window.addEventListener('DOMContentLoaded', (event) => {
	const shareLinks = document.querySelectorAll('.article__share-link');

	shareLinks.forEach(function (link) {
		link.addEventListener('click', function (e) {
			e.preventDefault();

			if (this.classList.contains('article__share-link--copy')) {
				if (navigator.clipboard) {
					navigator.clipboard
						.writeText(window.location.href)
						.then(function () {
							const notificaiton = document.querySelector(
								'.article-share__notification'
							);

							if (notificaiton) {
								notificaiton.classList.remove(
									'article-share__notification--hidden'
								);
								notificaiton.setAttribute(
									'aria-hidden',
									'false'
								);
							}
						});
				}
			} else {
				window.open(
					link.href,
					'',
					'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
				);
			}

			return false;
		});
	});

	const close = document.querySelector('.article-share__close');

	if (close) {
		close.addEventListener('click', function (e) {
			const notificaiton = document.querySelector(
				'.article-share__notification'
			);

			if (notificaiton) {
				notificaiton.classList.add(
					'article-share__notification--hidden'
				);
				notificaiton.setAttribute('aria-hidden', 'true');
			}
		});
	}
});
